/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */

/**
 * The kind of notification a resend repeats. Reminders carry no number on purpose: Statement History labels
 * reminders by position, so the profile's own number (Reminder3 on the autocharge track renders as
 * "Reminder 2") would contradict the timeline. String-serialized on the wire.
 */
export type ResendNotificationType =
  (typeof ResendNotificationType)[keyof typeof ResendNotificationType];

export const ResendNotificationType = {
  Statement: "Statement",
  Reminder: "Reminder",
  AutochargeScheduled: "AutochargeScheduled",
  AutochargeFailed: "AutochargeFailed",
  PaymentReceipt: "PaymentReceipt",
} as const;
